import { ErrorInfo } from 'App/components/ErrorInfo/ErrorInfo'
import { AppointmentConfirmation } from 'Views/appointment/AppointmentConfirmation'
import { AppointmentConfirmationTerms } from 'Views/appointmentConfirmationTerms/AppointmentConfirmationTerms'
import { DeleteAccount } from 'Views/DeleteAccount/DeleteAccount'
import { PaymentCheckout } from 'Views/PaymentCheckout/PaymentCheckout'
import { SurveyList } from 'Views/survey/components/SurveyList'
import { SurveyForm } from 'Views/survey/forms/SurveyForm'
import { Survey } from 'Views/survey/Survey'
import { Shopify } from 'Views/shopify/Shopify'

export const routes = [
	{
		name: 'survey',
		element: Survey,
		path: '/cuestionario/nom-035',
		wrapper: true,
	},
	{
		name: 'surveyList',
		element: SurveyList,
		path: '/cuestionario/nom-035/list',
		wrapper: true,
	},
	{
		name: 'surveyForm',
		element: SurveyForm,
		path: '/cuestionario/nom-035/list/form',
		wrapper: true,
	},
	{
		name: 'appointmentConfirmation',
		element: AppointmentConfirmation,
		path: '/candidato/confirmacion-cita',
		wrapper: true,
	},
	{
		name: 'appointmentConfirmationTerms',
		element: AppointmentConfirmationTerms,
		path: '/candidato/confirmacion-cita-termo',
		wrapper: true,
	},
	{
		name: 'error',
		element: ErrorInfo,
		path: '/error',
		wrapper: true,
	},
	{
		name: 'checkout',
		element: PaymentCheckout,
		path: '/payment-checkout',
		wrapper: false,
	},
	{
		name: 'deleteAccount',
		element: DeleteAccount,
		path: '/eliminar-cuenta',
		wrapper: false,
	},
	{
		name: 'welbe-shopify',
		element: Shopify,
		path: '/welbe-shopify',
		wrapper: false,
	},
]
